












import { IMarker } from "@/lib/interfaces/marker.interface";
import { Component, Prop, Vue } from "vue-property-decorator";

// export interface IMarker {
//   top: number;
//   left: number;
//   color?: string;
//   text?: string;
// }

@Component
export default class MImageMarkerMarker extends Vue {
  @Prop({ required: true }) marker!: IMarker;
  @Prop({ required: true }) containerWidth!: number;
  @Prop({ required: true }) containerHeight!: number;
  @Prop({ default: "medium" }) size!: "x-small" | "small" | "medium" | "large";
  @Prop({ default: false }) deactivated!: boolean;

  get markerDiameter() {
    switch (this.size) {
      case "x-small":
        return 10;
      case "small":
        return 15;
      case "medium":
        return 20;
      case "large":
        return 30;
      default:
        return 20;
    }
  }

  get markerFontSize() {
    switch (this.size) {
      case "small":
        return "xx-small";
      case "medium":
        return "xx-small";
      case "large":
        return "small";
      default:
        return "xx-small";
    }
  }

  get showText() {
    return this.size !== "x-small";
  }

  get markerClass() {
    return this.deactivated ? "marker-deactivated" : "marker-activated";
  }

  get style() {
    const topPx = this.marker.top * this.containerHeight;
    const leftPx = this.marker.left * this.containerWidth;
    const markerColor = this.marker.color || "#4283ff";

    return {
      position: "absolute",
      top: `${topPx}px`,
      left: `${leftPx}px`,
      transform: "translate(-50%, -50%)",
      width: `${this.markerDiameter}px`,
      height: `${this.markerDiameter}px`,
      fontSize: this.markerFontSize,
      backgroundColor: markerColor
    };
  }

  onMouseOver() {
    if (this.deactivated) {
      return;
    }

    this.$emit("mouseover", this.marker);
    this.$emit("hover", this.marker);
  }
}
